import React from 'react';
import firebase from '../../helper/firebase';

import {
	Avatar,
	Button,
	Card,
	CardContent,
	TextField,
	Typography
} from 'material-ui';

import Head from '../../components/Head';
import ApplicantCardHeader from '../../components/ApplicantCardHeader';
import LoggedOutCard from '../../components/LoggedOutCard';
import SectionTitle from '../../components/SectionTitle';
import ProfileIndustryCard from '../../components/ProfileIndustryCard';
import SkeletonCard from '../../components/SkeletonCard';
import SkeletonSectionTitle from '../../components/SkeletonSectionTitle';
import SkillsList from '../../components/SkillsList';
import AddSkill from '../../components/AddSkill';
import { LightGray, Title } from '../../helper/consts';

import AddAPhotoIcon from 'material-ui-icons/AddAPhoto';

import EditIcon from 'material-ui-icons/Edit';
import CancelIcon from 'material-ui-icons/Cancel';
import SaveIcon from 'material-ui-icons/Save';

import Fade from 'material-ui/transitions/Fade';

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	},
	profileRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center'
	},
	avatarRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	profileBtnContainer: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'nowrap'
	},
	smallBtn: {
		minWidth: '32px'
	},
	inactiveSmallBtn: {
		minWidth: '32px',
		color: LightGray
	},
	inputText: {
		color: 'initial'
	},
	avatarContainer: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'center',
		alignItems: 'flex-start',
		margin: '16px 0 8px'
	},
	logoAvatar: {
		cursor: 'pointer'
	},
	logoAvatarError: {
		backgroundColor: 'red'
	},
	avatarInstructions: {
		marginTop: '5px'
	}
};

export default class Profile extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			new_displayName: '',
			new_photoURL: ''
		};
	}

	handleFormInput = (e, formField) => {
		this.setState({
			[`${formField}`]: e.target.value
		});
	};

	handleAvatarSelect = e => {
		let file = e.target.files[0];
		if (file) {
			if (file.type.match('image')) {
				let reader = new FileReader(file);
				reader.onloadend = () => {
					this.setState({
						avatarFile: file,
						avatarFilename: file.name,
						new_photoURL: reader.result,
						avatarError: false,
						imageError: false
					});
				};
				if (file !== undefined) {
					reader.readAsDataURL(file);
				}
				// file!==undefined?reader.readAsDataURL(file):null
			} else {
				this.setState({
					avatarError: true,
					new_photoURL: '',
					avatarFile: null,
					avatarFilename: '',
					snackStatus: true,
					snackMessage: 'Error: Please upload (png,jpg,jpeg)'
				});
			}
		}
	};

	save = profileDetail => {
		let promises = [];
		const newDetail = this.state[`new_${profileDetail}`];
		const oldDetail = this.props.user[profileDetail];
		if (oldDetail === newDetail) return;
		const uid = this.props.uid;
		if (profileDetail === 'displayName') {
			const user = firebase.auth().currentUser;
			const authPromise = user.updateProfile({
				[profileDetail]: newDetail
			});
			promises.push(authPromise);
		}

		if (profileDetail === 'photoURL') {
			const { avatarFile } = this.state;
			const meta = {
				customMetadata: {
					name: avatarFile.name,
					uid
				}
			};
			let self = this;
			const storageRef = firebase.storage().ref(`users/${uid}/${uid}_photoURL`);
			const task = storageRef.put(avatarFile, meta);
			task.on(
				'state_changed',
				snapshot => {
					self.setState({
						uploadProgress: snapshot.bytesTransferred / snapshot.totalBytes / 2
					});
				},
				err => {
					console.log(err);
					this.setState({
						uploadProgress: 0,
						new_photoURL: '',
						avatarFile: null,
						avatarFilename: '',
						avatarError: true
					});
					this.props.actions.setSnack(
						true,
						`There was an error: ${err.code}. Please try again.`
					);
				},
				() => {
					storageRef
						.getMetadata()
						.then(metadata => {
							return metadata.downloadURLs[0];
						})
						.then(photoURL => {
							const user = firebase.auth().currentUser;
							let newDetail = photoURL;
							const ref = firebase.database().ref();
							const dbPromise = ref
								.child(`users/${uid}`)
								.update({ [profileDetail]: newDetail });
							promises.push(dbPromise);
							return user.updateProfile({
								photoURL: photoURL
							});
						})
						.catch(uploadError => {
							console.log(uploadError);
							this.setState({
								posting: false,
								posted: false,
								uploadProgress: 0
							});
							this.props.actions.setSnack(
								true,
								'Error Uploading. Please try again.'
							);
						});
				}
			);
			promises.push(task);
		}

		if (oldDetail !== newDetail && profileDetail !== 'photoURL') {
			const ref = firebase.database().ref();
			const dbPromise = ref
				.child(`users/${uid}`)
				.update({ [profileDetail]: newDetail });
			promises.push(dbPromise);
		}

		Promise.all(promises)
			.then(() => {
				this.setState({
					[`edit_${profileDetail}`]: false,
					new_displayName: '',
					new_photoURL: ''
				});
				this.props.actions.getProfileInfo(this.props.uid);
			})
			.catch(err => {
				this.props.actions.setSnack(true, `Error: ${err}`);
				console.log(err);
			});
	};

	renderProfile = () => {
		const { user } = this.props;
		let html = [];
		let card = (
			<Fade key="profile_summary" in={true}>
				<Card className="card">
					<ApplicantCardHeader applicant={user} />
				</Card>
			</Fade>
		);
		html.push(card);
		return html;
	};

	renderBasicProfileDetails = () => {
		let html = [];
		let card = (
			<Fade key="basic_profile_details" in={true}>
				<Card className="card">
					<CardContent>
						<div style={style.profileRow} className="displayName">
							<TextField
								style={this.state.edit_displayName ? null : style.inputText}
								error={this.state.displayNameError}
								fullWidth
								id="displayName"
								label="Display Name"
								placeholder="Full Name"
								value={
									this.state.edit_displayName
										? this.state.new_displayName
										: this.props.user ? this.props.user.displayName : ''
								}
								onChange={e => {
									this.handleFormInput(e, 'new_displayName');
								}}
								margin="normal"
								disabled={!this.state.edit_displayName}
							/>
							<div style={style.profileBtnContainer}>
								{this.state.edit_displayName ? (
									<Button
										style={style.smallBtn}
										className="cardActionsBtn"
										dense={true}
										onClick={() => {
											this.save('displayName');
										}}
										disabled={
											this.props.user.displayName ===
												this.state.new_displayName ||
											this.state.new_displayName.length === 0
										}
									>
										<SaveIcon />
									</Button>
								) : null}
								{this.state.edit_displayName ? (
									<Button
										style={style.smallBtn}
										className="cardActionsBtn"
										dense={true}
										onClick={() => {
											this.setState({ edit_displayName: false });
										}}
									>
										<CancelIcon />
									</Button>
								) : null}
								{!this.state.edit_displayName ? (
									<Button
										style={style.inactiveSmallBtn}
										className="cardActionsBtn"
										dense={true}
										onClick={() => {
											this.setState({ edit_displayName: true });
										}}
									>
										<EditIcon />
									</Button>
								) : null}
							</div>
						</div>
						<div style={style.avatarRow} className="displayName">
							<div style={style.avatarContainer} className="avatarContainer">
								{this.state.edit_photoURL && (
									<input
										onChange={this.handleAvatarSelect}
										accept="image"
										style={{ display: 'none' }}
										id="logo"
										multiple
										type="file"
									/>
								)}
								<label style={style.label} htmlFor="logo">
									<Avatar
										src={
											this.state.edit_photoURL
												? this.state.new_photoURL
												: this.props.user.photoURL
										}
										style={
											this.state.avatarError
												? style.logoAvatarError
												: this.state.edit_photoURL ? style.logoAvatar : null
										}
									>
										{this.state.edit_photoURL ? (
											this.state.new_photoURL.length === 0 ? (
												<AddAPhotoIcon />
											) : null
										) : !!!this.props.user.photoURL ? (
											this.props.user.displayName[0]
										) : null}
									</Avatar>
								</label>
								<Typography type="caption" style={style.avatarInstructions}>
									Max Size 1mb; Types: jpg,jpeg,png
								</Typography>
							</div>

							<div style={style.profileBtnContainer}>
								{this.state.edit_photoURL ? (
									<Button
										style={style.smallBtn}
										className="cardActionsBtn"
										dense={true}
										onClick={() => {
											this.save('photoURL');
										}}
										disabled={
											this.props.user.photoURL === this.state.new_photoURL ||
											this.state.new_photoURL.length === 0
										}
									>
										<SaveIcon />
									</Button>
								) : null}
								{this.state.edit_photoURL ? (
									<Button
										style={style.smallBtn}
										className="cardActionsBtn"
										dense={true}
										onClick={() => {
											this.setState({
												edit_photoURL: false,
												avatarFile: null,
												avatarFilename: '',
												new_photoURL: '',
												avatarError: false,
												imageError: false
											});
										}}
									>
										<CancelIcon />
									</Button>
								) : null}
								{!this.state.edit_photoURL ? (
									<Button
										style={style.inactiveSmallBtn}
										className="cardActionsBtn"
										dense={true}
										onClick={() => {
											this.setState({ edit_photoURL: true });
										}}
									>
										<EditIcon />
									</Button>
								) : null}
							</div>
						</div>
					</CardContent>
				</Card>
			</Fade>
		);
		html.push(card);
		return html;
	};

	renderSkillsCard = () => {
		let html = [];
		let card = (
			<Fade key="skills_card" in={true}>
				<Card className="card">
					<CardContent>
						<SkillsList uid={this.props.uid} skills={this.props.skills} />
						<AddSkill
							setSnack={this.props.actions.setSnack}
							uid={this.props.uid}
						/>
					</CardContent>
				</Card>
			</Fade>
		);
		html.push(card);
		return html;
	};

	render() {
		return (
			<React.Fragment>
				<Head title={`Profile | ${Title}`} />
				<div id={this.props.loggedIn ? 'loggedInBody' : null} className="body">
					{this.props.profileLoading &&
						this.props.loggedIn && <SkeletonSectionTitle />}
					{this.props.profileLoading &&
						this.props.loggedIn && <SkeletonCard header={true} />}
					{!this.props.profileLoading &&
						this.props.loggedIn && <SectionTitle title="Profile" />}
					{!this.props.profileLoading &&
						this.props.loggedIn &&
						this.renderProfile()}

					{this.props.profileLoading &&
						this.props.loggedIn && <SkeletonSectionTitle />}
					{this.props.profileLoading &&
						this.props.loggedIn && <SkeletonCard header={true} />}
					{!this.props.profileLoading &&
						this.props.loggedIn && <SectionTitle title="Basic Details" />}
					{!this.props.profileLoading &&
						this.props.loggedIn &&
						this.renderBasicProfileDetails()}

					{this.props.profileLoading &&
						this.props.loggedIn && <SkeletonSectionTitle />}
					{this.props.profileLoading &&
						this.props.loggedIn && <SkeletonCard header={true} />}
					{!this.props.profileLoading &&
						this.props.loggedIn && <SectionTitle title="Additional Details" />}
					{!this.props.profileLoading &&
						this.props.loggedIn && (
							<ProfileIndustryCard profile={this.props.user} />
						)}

					{this.props.loggedIn &&
						this.props.skillsLoading && <SkeletonSectionTitle />}
					{this.props.loggedIn &&
						this.props.skillsLoading && <SkeletonCard header={true} />}
					{this.props.loggedIn &&
						!this.props.skillsLoading && <SectionTitle title="Skills" />}
					{this.props.loggedIn &&
						!this.props.skillsLoading &&
						this.renderSkillsCard()}

					{!this.props.authLoading && !this.props.loggedIn ? (
						<LoggedOutCard />
					) : null}
				</div>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/Profile/Profile.js